import { httpV2 } from "../http";

const base = "/identity-verifications";

const clientEventId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
};

const IdentityVerificationService = {
  getStatus: async (guestReservationId) => {
    const response = await httpV2.get(`${base}/status/${guestReservationId}`);
    return response.data;
  },

  createWorkspaceToken: async (guestReservationId, reason = "initial") => {
    const response = await httpV2.post(
      `${base}/verifications/${guestReservationId}/workspace-token`,
      { reason },
    );
    return response.data;
  },

  refreshStatus: async (guestReservationId) => {
    const response = await httpV2.post(
      `${base}/status/${guestReservationId}/refresh`,
    );
    return response.data;
  },

  recordReviewDecisionSubmitted: async (guestReservationId, baselineStatus) => {
    const response = await httpV2.post(
      `${base}/verifications/${guestReservationId}/review-events`,
      {
        event_type: "decision_submitted",
        client_event_id: clientEventId(),
        baseline_status: baselineStatus || null,
      },
    );
    return response.data;
  },
};

export default IdentityVerificationService;
